<template>
  <div class="admin-container">
    <!-- 后台管理专用导航栏 -->
    <div class="admin-nav">
      <div class="nav-content">
        <div class="nav-left">
          <div class="logo">
            <i class="el-icon-s-management"></i>
            <span>后台管理</span>
          </div>
          <div class="nav-tabs">
            <div
              v-for="tab in navTabs"
              :key="tab.key"
              :class="['nav-tab', { active: activeTab === tab.key }]"
              @click="switchTab(tab.key)"
            >
              <i :class="tab.icon"></i>
              <span>{{ tab.label }}</span>
            </div>
          </div>
        </div>
        <div class="nav-right">
          <div class="user-info">
            <i class="el-icon-user"></i>
            <span>{{ user.username }}</span>
          </div>
          <el-button type="text" @click="handleLogout" class="logout-btn">
            <i class="el-icon-switch-button"></i>
            退出登录
          </el-button>
        </div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="admin-content">
      <!-- 新闻管理 -->
      <div v-if="activeTab === 'news'" class="content-section">
        <div class="section-header">
          <h3><i class="el-icon-document-copy"></i>新闻管理</h3>
          <el-button type="primary" @click="showNewsDialog()">
            <i class="el-icon-plus"></i>
            添加新闻
          </el-button>
        </div>

        <!-- 新闻列表 -->
        <div class="data-table">
          <el-table :data="newsList" style="width: 100%" v-loading="loading.news">
            <el-table-column prop="publishTime" label="发布时间" width="160">
              <template slot-scope="scope">
                {{ formatDate(scope.row.publishTime) }}
              </template>
            </el-table-column>
            <el-table-column prop="title" label="标题" min-width="200">
              <template slot-scope="scope">
                <div class="title-cell">
                  <div class="title-text">{{ scope.row.title }}</div>

                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="180" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="editNews(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="deleteNews(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            @current-change="handleNewsPageChange"
            :current-page="pagination.news.currentPage"
            :page-size="pagination.news.pageSize"
            layout="prev, pager, next, jumper"
            :total="pagination.news.total"
          ></el-pagination>
        </div>
      </div>

      <!-- 产品管理 -->
      <div v-if="activeTab === 'product'" class="content-section">
        <div class="section-header">
          <h3><i class="el-icon-s-shop"></i>产品管理</h3>
          <el-button type="primary" @click="showProductDialog()">
            <i class="el-icon-plus"></i>
            添加产品
          </el-button>
        </div>

        <div class="data-table">
          <el-table :data="productList" style="width: 100%" v-loading="loading.product">
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column prop="name" label="产品名称" min-width="150"></el-table-column>
            <el-table-column prop="category" label="分类" width="120"></el-table-column>
            <el-table-column prop="description" label="描述" min-width="200">
              <template slot-scope="scope">
                <div class="description-cell">{{ scope.row.description }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="创建时间" width="160">
              <template slot-scope="scope">
                {{ formatDate(scope.row.createdAt) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="editProduct(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="deleteProduct(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination">
          <el-pagination
            @current-change="handleProductPageChange"
            :current-page="pagination.product.currentPage"
            :page-size="pagination.product.pageSize"
            layout="prev, pager, next, jumper"
            :total="pagination.product.total"
          ></el-pagination>
        </div>
      </div>

      <!-- 方案管理 -->
      <div v-if="activeTab === 'solution'" class="content-section">
        <div class="section-header">
          <h3><i class="el-icon-s-order"></i>方案管理</h3>
          <el-button type="primary" @click="showSolutionDialog()">
            <i class="el-icon-plus"></i>
            添加方案
          </el-button>
        </div>

        <div class="data-table">
          <el-table :data="solutionList" style="width: 100%" v-loading="loading.solution">
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column prop="title" label="方案标题" min-width="150"></el-table-column>
            <el-table-column prop="industry" label="行业" width="120"></el-table-column>
            <el-table-column prop="summary" label="摘要" min-width="200">
              <template slot-scope="scope">
                <div class="description-cell">{{ scope.row.summary }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="创建时间" width="160">
              <template slot-scope="scope">
                {{ formatDate(scope.row.createdAt) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="editSolution(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="deleteSolution(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination">
          <el-pagination
            @current-change="handleSolutionPageChange"
            :current-page="pagination.solution.currentPage"
            :page-size="pagination.solution.pageSize"
            layout="prev, pager, next, jumper"
            :total="pagination.solution.total"
          ></el-pagination>
        </div>
      </div>

      <!-- 雪亮工程工具激活记录 -->
      <div v-if="activeTab === 'license'" class="content-section">
        <div class="section-header">
          <h3><i class="el-icon-s-order"></i>雪亮工程处理工具激活记录</h3>
        </div>

        <div class="data-table">
          <el-table :data="licenseList" style="width: 100%" v-loading="loading.license">
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column prop="name" label="姓名" width="250"></el-table-column>
            <el-table-column prop="code" label="注册码" width="320"></el-table-column>
            <el-table-column prop="remark" label="申请原因" min-width="320"></el-table-column>
            <el-table-column prop="created_at" label="时间" width="160">
              <template slot-scope="scope">
                {{ formatDate(scope.row.created_at) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="deleteLicenses(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination">
          <el-pagination
            @current-change="handleLicensePageChange"
            :current-page="pagination.license.currentPage"
            :page-size="pagination.license.pageSize"
            layout="prev, pager, next, jumper"
            :total="pagination.license.total"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新闻编辑对话框 -->
    <el-dialog
      :title="newsDialogTitle"
      :visible.sync="newsDialogVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="newsForm" :rules="newsRules" ref="newsForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="24" >
            <el-form-item label="文章链接" prop="source_url">
              <el-input v-model="newsForm.source_url" placeholder="输入公众号文章链接进行自动抓取">
                <el-button slot="append" :loading="crawling" @click="handleCrawl" >一键抓取</el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="标题" prop="title">
              <el-input v-model="newsForm.title" placeholder="请输入新闻标题"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="摘要" prop="summary">
              <el-input v-model="newsForm.summary" type="textarea" rows="3" placeholder="请输入新闻摘要"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="封面图" prop="cover_image">
              <el-input v-model="newsForm.cover_image" placeholder="封面图片地址"></el-input>
            </el-form-item>
            <!-- 封面图预览 -->
            <div v-if="newsForm.cover_image" class="image-preview">
              <img :src="newsForm.cover_image" alt="封面图预览" @error="onImageError" referrerpolicy="no-referrer" 
              referrer="no-referrer"/>
              <div class="preview-label">封面图预览</div>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="作者" prop="author">
              <el-input v-model="newsForm.author" placeholder="请输入作者"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="发布日期" prop="publish_time">
              <el-date-picker
                v-model="newsForm.publish_time"
                 type="date"
                placeholder="请选择发布日期"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="公众号文章链接">
              <el-input v-model="newsForm.source_url" placeholder="文章链接"></el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="24">
            <el-form-item label="状态">
              <el-radio-group v-model="newsForm.status">
                <el-radio label="published">已发布</el-radio>
                <el-radio label="draft">草稿</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="正文" prop="content">
              <el-input v-model="newsForm.content" type="textarea" rows="8" placeholder="请输入新闻正文内容"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="newsDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving.news" @click="submitNewsForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 产品编辑对话框 -->
    <el-dialog
      :title="productDialogTitle"
      :visible.sync="productDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form :model="productForm" :rules="productRules" ref="productForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="产品名称" prop="name">
              <el-input v-model="productForm.name" placeholder="请输入产品名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分类" prop="category">
              <el-input v-model="productForm.category" placeholder="请输入产品分类"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="描述" prop="description">
              <el-input v-model="productForm.description" type="textarea" rows="4" placeholder="请输入产品描述"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="功能特性">
              <el-input v-model="productForm.featuresStr" type="textarea" rows="3" placeholder="多个功能用逗号分隔，如：实时监控,数据分析"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图片地址">
              <el-input v-model="productForm.imagesStr" type="textarea" rows="3" placeholder="多个图片地址用逗号分隔"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="状态">
              <el-radio-group v-model="productForm.status">
                <el-radio label="active">正常</el-radio>
                <el-radio label="inactive">下架</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="productDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving.product" @click="submitProductForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 方案编辑对话框 -->
    <el-dialog
      :title="solutionDialogTitle"
      :visible.sync="solutionDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form :model="solutionForm" :rules="solutionRules" ref="solutionForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="方案标题" prop="title">
              <el-input v-model="solutionForm.title" placeholder="请输入方案标题"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="行业" prop="industry">
              <el-input v-model="solutionForm.industry" placeholder="请输入适用行业"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="摘要" prop="summary">
              <el-input v-model="solutionForm.summary" type="textarea" rows="3" placeholder="请输入方案摘要"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="封面图">
              <el-input v-model="solutionForm.cover_image" placeholder="封面图片地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="正文内容" prop="content">
              <el-input v-model="solutionForm.content" type="textarea" rows="6" placeholder="请输入方案详细内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图片地址">
              <el-input v-model="solutionForm.imagesStr" type="textarea" rows="3" placeholder="多个图片地址用逗号分隔"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="状态">
              <el-radio-group v-model="solutionForm.status">
                <el-radio label="active">正常</el-radio>
                <el-radio label="inactive">下架</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="solutionDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving.solution" @click="submitSolutionForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Admin',
  data() {
    return {
      activeTab: 'news',
      navTabs: [
        { key: 'news', label: '新闻管理', icon: 'el-icon-document-copy' },
        // { key: 'product', label: '产品管理', icon: 'el-icon-s-shop' },
        // { key: 'solution', label: '方案管理', icon: 'el-icon-s-order' }
        { key: 'license', label: '激活记录', icon: 'el-icon-document-copy' },
      ],
      crawling: false,
      saving: {
        news: false,
        product: false,
        solution: false
      },
      loading: {
        news: false,
        product: false,
        solution: false,
        license:false,
      },
      newsList: [],
      productList: [],
      solutionList: [],
      licenseList: [],
      pagination: {
        news: { currentPage: 1, pageSize: 10, total: 0 },
        product: { currentPage: 1, pageSize: 10, total: 0 },
        solution: { currentPage: 1, pageSize: 10, total: 0 },
        license: { currentPage: 1, pageSize: 10, total: 0 },
      },
      // 对话框状态
      newsDialogVisible: false,
      productDialogVisible: false,
      solutionDialogVisible: false,
      newsDialogTitle: '添加新闻',
      productDialogTitle: '添加产品',
      solutionDialogTitle: '添加方案',
      // 表单数据
      newsForm: {
        id: null,
        title: '',
        summary: '',
        cover_image: '',
        source_url: '',
        publish_time: new Date(),
      },
      productForm: {
        id: null,
        name: '',
        description: '',
        category: '',
        featuresStr: '',
        imagesStr: '',
        status: 'active'
      },
      solutionForm: {
        id: null,
        title: '',
        summary: '',
        cover_image: '',
        industry: '',
        content: '',
        imagesStr: '',
        status: 'active'
      },
      // 表单验证规则
      newsRules: {
        title: [{ required: true, message: '请输入新闻标题', trigger: 'blur' }],
        summary: [{ required: true, message: '请输入新闻摘要', trigger: 'blur' }],
        source_url: [{ required: true, message: '请输入公众号文章链接', trigger: 'blur' }],
        cover_image: [{ required: true, message: '请输入封面图地址', trigger: 'blur' }],
        publish_time: [{ required: true, message: '请选择发布时间', trigger: 'change' }]
      },
      productRules: {
        name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        category: [{ required: true, message: '请输入产品分类', trigger: 'blur' }],
        description: [{ required: true, message: '请输入产品描述', trigger: 'blur' }]
      },
      solutionRules: {
        title: [{ required: true, message: '请输入方案标题', trigger: 'blur' }],
        industry: [{ required: true, message: '请输入适用行业', trigger: 'blur' }],
        summary: [{ required: true, message: '请输入方案摘要', trigger: 'blur' }],
        content: [{ required: true, message: '请输入方案内容', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapState(['user'])
  },
  created() {
    this.loadData()
  },
  methods: {
    ...mapActions(['logout']),

    // 标签页切换
    switchTab(tab) {
      this.activeTab = tab
      this.loadData()
    },

    // 加载数据
    async loadData() {
      if (this.activeTab === 'news') {
        await this.loadNews()
      } else if (this.activeTab === 'product') {
        await this.loadProducts()
      } else if (this.activeTab === 'solution') {
        await this.loadSolutions()
      }else if (this.activeTab === 'license') {
        await this.loadLicense()
      }
    },

    // 新闻相关方法
    async loadNews() {
      this.loading.news = true
      try {
        const res = await request.get('/news/admin/list', {
          params: {
            page: this.pagination.news.currentPage,
            pageSize: this.pagination.news.pageSize
          }
        })
        if (res.success) {
          this.newsList = res.data.newsList || []
          this.pagination.news.total = res.data.total || 0
        }
      } catch (error) {
        this.$message.error('加载新闻列表失败')
      } finally {
        this.loading.news = false
      }
    },

    async handleNewsPageChange(page) {
      this.pagination.news.currentPage = page
      await this.loadNews()
    },

    showNewsDialog(news = null) {
      this.newsDialogTitle = news ? '编辑新闻' : '添加新闻'
      if (news) {
        // 将后端返回的驼峰命名字段转换为表单使用的下划线命名字段
        this.newsForm = {
          id: news.id,
          title: news.title,
          summary: news.summary,
          content: news.content || '',
          cover_image: news.coverImage,
          author: news.author,
          source_url: news.sourceUrl,
          publish_time: news.publishTime ? new Date(news.publishTime) : new Date(),
          status: news.status || 'published'
        }
      } else {
        this.resetNewsForm()
      }
      this.newsDialogVisible = true
    },

    resetNewsForm() {
      this.newsForm = {
        id: null,
        title: '',
        summary: '',
        cover_image: '',
        source_url: '',
        publish_time: new Date(),

      }
    },

    async handleCrawl() {
      if (!this.newsForm.source_url) {
        this.$message.warning('请先输入链接')
        return
      }
      this.crawling = true
      try {
        const res = await request.post('/news/crawl', { url: this.newsForm.source_url })
        if (res.success) {
          // 处理发布时间，只保留日期部分
          let publishTime = new Date()
          if (res.data.publishTime) {
            // 从字符串中提取日期部分，如"2025年12月5日 08:40" -> "2025-12-5"
            const dateStr = res.data.publishTime.split(' ')[0] // 获取日期部分
            const dateMatch = dateStr.match(/(\d{4})年(\d{1,2})月(\d{1,2})日/)
            if (dateMatch) {
              const [, year, month, day] = dateMatch
              publishTime = new Date(year, month - 1, day) // 月份需要减1
            }
          }
          // if (res.data.coverImage) {
          //   //把http地址改为https
          //   res.data.coverImage = res.data.coverImage.replace('http', 'https')
          // }

          Object.assign(this.newsForm, {
            title: res.data.title,
            summary: res.data.summary,
            cover_image: res.data.coverImage,
            author: res.data.author,
            source_url: res.data.sourceUrl, // 使用正确的字段名sourceUrl
            publish_time: publishTime
          })
          this.$message.success('抓取成功，已自动填充')
        } else {
          this.$message.error(res.error || '抓取失败')
        }
      } catch (error) {
        this.$message.error(error?.response?.data?.error || '抓取失败')
      } finally {
        this.crawling = false
      }
    },

    async submitNewsForm() {
      try {
        await this.$refs.newsForm.validate()
      } catch (error) {
        return
      }

      this.saving.news = true
      try {
        // 构建后端期望的数据结构
        const payload = {
          title: this.newsForm.title,
          summary: this.newsForm.summary,
          content: this.newsForm.content,
          coverImage: this.newsForm.cover_image,  // 转换为后端期望的字段名
          author: this.newsForm.author,
          sourceUrl: this.newsForm.source_url,    // 转换为后端期望的字段名
          publishTime: this.newsForm.publish_time ? this.formatDateForAPI(this.newsForm.publish_time) : null, // 转换为后端期望的字段名
          status: 'published'
        }

        console.log('前端发送的payload:', payload);

        const res = this.newsForm.id
          ? await request.put(`/news/${this.newsForm.id}`, payload)
          : await request.post('/news', payload)

        if (res.success) {
          this.$message.success(this.newsForm.id ? '新闻更新成功' : '新闻添加成功')
          this.newsDialogVisible = false
          await this.loadNews()
        } else {
          this.$message.error(res.error || '操作失败')
        }
      } catch (error) {
        this.$message.error(error?.response?.data?.error || '操作失败')
      } finally {
        this.saving.news = false
      }
    },

    editNews(news) {
      this.showNewsDialog(news)
    },

    async deleteNews(news) {
      try {
        await this.$confirm('确定要删除这条新闻吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        return
      }

      try {
        const res = await request.delete(`/news/${news.id}`)
        if (res.success) {
          this.$message.success('新闻删除成功')
          await this.loadNews()
        } else {
          this.$message.error(res.error || '删除失败')
        }
      } catch (error) {
        this.$message.error(error?.response?.data?.error || '删除失败')
      }
    },

    // 产品相关方法
    async loadProducts() {
      this.loading.product = true
      try {
        const res = await request.get('/products/admin/list', {
          params: {
            page: this.pagination.product.currentPage,
            pageSize: this.pagination.product.pageSize
          }
        })
        if (res.success) {
          this.productList = res.data.products || []
          this.pagination.product.total = res.data.total || 0
        }
      } catch (error) {
        this.$message.error('加载产品列表失败')
      } finally {
        this.loading.product = false
      }
    },

    async handleProductPageChange(page) {
      this.pagination.product.currentPage = page
      await this.loadProducts()
    },

    showProductDialog(product = null) {
      this.productDialogTitle = product ? '编辑产品' : '添加产品'
      if (product) {
        this.productForm = {
          ...product,
          featuresStr: product.features ? product.features.join(', ') : '',
          imagesStr: product.images ? product.images.join(', ') : ''
        }
      } else {
        this.resetProductForm()
      }
      this.productDialogVisible = true
    },

    resetProductForm() {
      this.productForm = {
        id: null,
        name: '',
        description: '',
        category: '',
        featuresStr: '',
        imagesStr: '',
        status: 'active'
      }
    },

    async submitProductForm() {
      try {
        await this.$refs.productForm.validate()
      } catch (error) {
        return
      }

      this.saving.product = true
      try {
        const payload = {
          name: this.productForm.name,
          description: this.productForm.description,
          category: this.productForm.category,
          features: this.productForm.featuresStr ? this.productForm.featuresStr.split(',').map(v => v.trim()).filter(Boolean) : [],
          images: this.productForm.imagesStr ? this.productForm.imagesStr.split(',').map(v => v.trim()).filter(Boolean) : [],
          status: this.productForm.status
        }

        const res = this.productForm.id
          ? await request.put(`/products/${this.productForm.id}`, payload)
          : await request.post('/products', payload)

        if (res.success) {
          this.$message.success(this.productForm.id ? '产品更新成功' : '产品添加成功')
          this.productDialogVisible = false
          await this.loadProducts()
        } else {
          this.$message.error(res.error || '操作失败')
        }
      } catch (error) {
        this.$message.error(error?.response?.data?.error || '操作失败')
      } finally {
        this.saving.product = false
      }
    },

    editProduct(product) {
      this.showProductDialog(product)
    },

    async deleteProduct(product) {
      try {
        await this.$confirm('确定要删除这个产品吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        return
      }

      try {
        const res = await request.delete(`/products/${product.id}`)
        if (res.success) {
          this.$message.success('产品删除成功')
          await this.loadProducts()
        } else {
          this.$message.error(res.error || '删除失败')
        }
      } catch (error) {
        this.$message.error(error?.response?.data?.error || '删除失败')
      }
    },

    // 方案相关方法
    async loadSolutions() {
      this.loading.solution = true
      try {
        const res = await request.get('/solutions/admin/list', {
          params: {
            page: this.pagination.solution.currentPage,
            pageSize: this.pagination.solution.pageSize
          }
        })
        if (res.success) {
          this.solutionList = res.data.solutions || []
          this.pagination.solution.total = res.data.total || 0
        }
      } catch (error) {
        this.$message.error('加载方案列表失败')
      } finally {
        this.loading.solution = false
      }
    },

    async handleSolutionPageChange(page) {
      this.pagination.solution.currentPage = page
      await this.loadSolutions()
    },

    showSolutionDialog(solution = null) {
      this.solutionDialogTitle = solution ? '编辑方案' : '添加方案'
      if (solution) {
        this.solutionForm = {
          ...solution,
          imagesStr: solution.images ? solution.images.join(', ') : ''
        }
      } else {
        this.resetSolutionForm()
      }
      this.solutionDialogVisible = true
    },

    resetSolutionForm() {
      this.solutionForm = {
        id: null,
        title: '',
        summary: '',
        cover_image: '',
        industry: '',
        content: '',
        imagesStr: '',
        status: 'active'
      }
    },

    async submitSolutionForm() {
      try {
        await this.$refs.solutionForm.validate()
      } catch (error) {
        return
      }

      this.saving.solution = true
      try {
        const payload = {
          title: this.solutionForm.title,
          summary: this.solutionForm.summary,
          cover_image: this.solutionForm.cover_image,
          industry: this.solutionForm.industry,
          content: this.solutionForm.content,
          images: this.solutionForm.imagesStr ? this.solutionForm.imagesStr.split(',').map(v => v.trim()).filter(Boolean) : [],
          status: this.solutionForm.status
        }

        const res = this.solutionForm.id
          ? await request.put(`/solutions/${this.solutionForm.id}`, payload)
          : await request.post('/solutions', payload)

        if (res.success) {
          this.$message.success(this.solutionForm.id ? '方案更新成功' : '方案添加成功')
          this.solutionDialogVisible = false
          await this.loadSolutions()
        } else {
          this.$message.error(res.error || '操作失败')
        }
      } catch (error) {
        this.$message.error(error?.response?.data?.error || '操作失败')
      } finally {
        this.saving.solution = false
      }
    },

    editSolution(solution) {
      this.showSolutionDialog(solution)
    },

    async deleteSolution(solution) {
      try {
        await this.$confirm('确定要删除这个方案吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        return
      }

      try {
        const res = await request.delete(`/solutions/${solution.id}`)
        if (res.success) {
          this.$message.success('方案删除成功')
          await this.loadSolutions()
        } else {
          this.$message.error(res.error || '删除失败')
        }
      } catch (error) {
        this.$message.error(error?.response?.data?.error || '删除失败')
      }
    },

    // 激活记录相关方法
    async loadLicense() {
      this.loading.license = true
      try {
        const res = await request.get('/licenses/list', {
          params: {
            page: this.pagination.license.currentPage,
            pageSize: this.pagination.product.pageSize
          }
        })
        if (res.success) {
          this.licenseList = res.data.licensesList || []
          this.pagination.license.total = res.data.total || 0
        }
      } catch (error) {
        this.$message.error('加载激活记录列表失败')
      } finally {
        this.loading.license = false
      }
    },
    async deleteLicenses(licenses) {
      try {
        await this.$confirm('确定要删除这条记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        return
      }

      try {
        const res = await request.delete(`/licenses/${licenses.id}`)
        if (res.success) {
          this.$message.success('记录删除成功')
          await this.loadLicense()
        } else {
          this.$message.error(res.error || '删除失败')
        }
      } catch (error) {
        this.$message.error(error?.response?.data?.error || '删除失败')
      }
    },

    async handleLicensePageChange(page) {
      this.pagination.product.currentPage = page
      await this.loadLicense()
    },

    // 工具方法
    formatDate(dateString) {
      if (!dateString) return '-'
      try {
        const date = new Date(dateString)
        return date.toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
      } catch (e) {
        return dateString
      }
    },

    // 图片加载错误处理
    onImageError() {
      this.$message.warning('图片加载失败，请检查图片地址是否正确')
    },

    // 格式化日期为API使用的格式，避免时区问题
    formatDateForAPI(date) {
      if (!date) return null

      // 获取本地日期的年月日，避免时区转换问题
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始，需要+1
      const day = String(date.getDate()).padStart(2, '0')

      // 返回本地日期字符串，后端可以正确解析
      return `${year}-${month}-${day}`
    },

    handleLogout() {
      this.logout()
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.admin-container {
  min-height: 100vh;
  background: #f8fafc;
}

/* 导航栏样式 */
.admin-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.nav-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  height: 64px;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 32px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
}

.logo i {
  color: #3b82f6;
  font-size: 20px;
}

.nav-tabs {
  display: flex;
  gap: 4px;
}

.nav-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
  font-weight: 500;
}

.nav-tab:hover {
  background: #f3f4f6;
  color: #374151;
}

.nav-tab.active {
  background: #3b82f6;
  color: white;
}

.nav-tab i {
  font-size: 16px;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-size: 14px;
}

.user-info i {
  color: #9ca3af;
}

.logout-btn {
  width:150px;
  color: #dc2626;
  border-color: #dc2626;
  transition: all 0.2s ease;
}

.logout-btn:hover {
  background: #dc2626;
  color: white;
}

/* 内容区域样式 */
.admin-content {
  padding-top: 80px;
  padding: 80px 24px 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.content-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.section-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-header h3 i {
  color: #3b82f6;
}

/* 数据表格样式 */
.data-table {
  padding: 0;
}

.data-table .el-table {
  border: none;
}

.data-table .el-table::before {
  display: none;
}

.data-table .el-table th {
  background: #f9fafb;
  color: #374151;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  padding: 12px 16px;
}

.data-table .el-table td {
  border-bottom: 1px solid #f3f4f6;
  padding: 12px 16px;
}

.data-table .el-table tbody tr:hover > td {
  background: #f9fafb;
}

.title-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-text {
  font-weight: 500;
  color: #1f2937;
}

.description-cell {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #6b7280;
}

/* 分页样式 */
.pagination {
  padding: 20px 24px;
  text-align: center;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}

/* 对话框样式 */
.dialog-footer {
  text-align: right;
}

.dialog-footer .el-button {
  min-width: 80px;
}

/* 图片预览样式 */
.image-preview {
  margin-top: 10px;
  text-align: center;
}

.image-preview img {
  max-width: 200px;
  max-height: 150px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.preview-label {
  margin-top: 8px;
  font-size: 12px;
  color: #6b7280;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .nav-left {
    gap: 16px;
  }

  .nav-tabs {
    gap: 2px;
  }

  .nav-tab {
    padding: 8px 12px;
    font-size: 14px;
  }

  .nav-tab span {
    display: none;
  }

  .nav-tab i {
    margin-right: 0;
  }
}

@media (max-width: 768px) {
  .nav-content {
    padding: 0 16px;
    height: 56px;
  }

  .nav-left {
    gap: 12px;
  }

  .nav-tabs {
    display: none;
  }

  .logo {
    font-size: 16px;
  }

  .admin-content {
    padding: 72px 16px 16px;
  }

  .section-header {
    padding: 16px;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .section-header h3 {
    font-size: 16px;
  }

  .data-table .el-table {
    font-size: 14px;
  }

  .data-table .el-table th,
  .data-table .el-table td {
    padding: 8px 12px;
  }

  .pagination {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .nav-content {
    padding: 0 12px;
  }

  .user-info span {
    display: none;
  }

  .admin-content {
    padding: 68px 8px 8px;
  }

  .content-section {
    border-radius: 8px;
  }

  .section-header {
    padding: 12px;
  }
}
</style>
